<template>

    <div v-if="showMe">
        
        <v-row id="widj-box" class="p-0">
            <v-col class="pt-0">

                <v-row id="top-box">
                    <v-col class="text-center">
                        League Table
                    </v-col>
                </v-row>
                
                <v-row>
                    <v-col>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th class="px-0">Pos</th>
                                    <th class="px-0">Player</th>
                                    <th class="px-0">Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in topFive" :key="row.user_id">
                                    <td class="px-0">
                                        <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon 
                                                class="mr-1" 
                                                size="14px" 
                                                v-bind="attrs"
                                                v-on="on"
                                                :color="getIconColour(row.rankChange)"
                                            >{{ getIcon(row.rankChange) }}
                                            </v-icon> {{ row.rank }}
                                        </template>
                                        <span>{{ getChange(row.rankChange) }}</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="px-0">{{ row.username }}</td>
                                    <td class="px-0">{{ row.totPoints }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>        
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-0">
                        <v-btn  class="float-right" x-small outlined color="secondary" @click="$router.push('league')">View Full Table</v-btn>
                    </v-col>
                </v-row>
                
            </v-col>
        </v-row>

    </div>

</template>

<script>

import {mapGetters} from "vuex";

export default {
    name: "LeagueWidget",
    props: [
      //
    ],
    components: {
      //
    },
    data: () => ({
        showMe: false,
    }),
    computed: {
        ...mapGetters([
            'weekInfo',
            'league',
        ]),
        topFive() {
            if (this.league) {
                return this.league.slice(0,5);
            }
        }
    },
    methods: {
    getIcon(rankChange) {
        if (rankChange > 0) {
          return 'mdi-arrow-up-circle';  
        } else if (rankChange < 0) {
          return 'mdi-arrow-down-circle'
        }
        return 'mdi-minus-circle'
      },
      getIconColour(rankChange) {
        if (rankChange > 0) {
          return 'green';  
        } else if (rankChange < 0) {
          return 'red'
        }
        return 'yellow darken-2'
      },
      getChange(rankChange) {
        const places = Math.abs(rankChange) === 1 ? 'place' : 'places';
        if (rankChange > 0) {
          return `up ${ rankChange } ${ places }`;  
        } else if (rankChange < 0) {
          return `down ${ Math.abs(rankChange) } ${ places }`
        }
        return 'no change'
      }
    },
    created() {
        if (!this.league) {
            this.$store.dispatch('getLeague');
        } else {
            this.showMe = true;
        }
        
        this.unwatchleague = this.$store.watch(
            (state, getters) => getters.league,
            (newValue, oldValue) => {
                this.showMe = true;
            }
        )
    },
    beforeDestroy() {
        this.unwatchleague();
    }

}
</script>

<style scoped>

    #widj-box {
        border: 2px solid var(--v-secondary-base);
        background-color: #EFEBE9;
    }

    #top-box {
        background-color: var(--v-secondary-base);
        color: #fff;
    }

    .link-btn {
        color: black !important;
    }

    .v-data-table>.v-data-table__wrapper>table>tbody>tr>td{
        background-color: #EFEBE9;
        font-size: 0.8rem;
    }
    .v-data-table>.v-data-table__wrapper>table>thead>tr>th{
        background-color: #EFEBE9;
        font-size: 0.8rem;
    }

</style>
